// Chaînes du bouton « J'ai déjà réglé » sur la page publique de paiement
// (/pay/:token). Clés préfixées "declare." — voir i18n/index.js.
// ⚠️ Les codes envoyés au serveur (especes, cheque, virement, autre) ne sont
// PAS traduits : seuls les libellés affichés le sont.
const declare = {
  fr: {
    // — Lien sur la page de paiement —
    "declare.link_title": "J'ai déjà réglé",
    "declare.link_hint": "Espèces, chèque ou virement déjà remis\u00a0? Dites-le-nous, le gabbaï vérifiera.",

    // — Écran « Comment avez-vous réglé ? » —
    "declare.back": "Retour au paiement",
    "declare.title": "Comment avez-vous réglé\u00a0?",
    "declare.for_pledge": "Pour\u00a0: {motive} — {amount}",
    "declare.method_especes": "Espèces",
    "declare.method_cheque": "Chèque",
    "declare.method_virement": "Virement",
    "declare.method_autre": "Autre",
    "declare.date_label": "Date du règlement",
    "declare.note_label": "Un mot pour le gabbaï",
    "declare.note_placeholder": "Ex.\u00a0: chèque remis après l'office de Chabbat",
    "declare.optional": "facultatif",
    "declare.submit": "Envoyer",
    "declare.choose_first": "Choisissez d'abord comment vous avez réglé.",
    "declare.error": "Envoi impossible — réessayez.",
    "declare.error_rate": "Trop de tentatives. Réessayez dans quelques minutes.",
    "declare.error_closed": "Ce lien n'est plus valable pour signaler un règlement.",
    "declare.error_settled": "Cette promesse est déjà enregistrée comme réglée. Rien à signaler, merci\u00a0!",
    "declare.error_refused": "La synagogue a déjà vérifié votre déclaration. Contactez le gabbaï.",
    "declare.choose_pledge": "Revenez à la page de paiement et cochez la promesse que vous avez déjà réglée.",

    // — Plus rien à régler sur ce lien —
    "declare.nothing_title": "Tout est réglé, merci\u00a0!",
    "declare.nothing_body": "Aucune promesse n'attend de paiement sur ce lien.",

    // — Pastille sur une ligne de la page de paiement —
    "declare.line_badge": "Signalé réglé le {date} — le gabbaï vérifie",
    "declare.line_badge_nodate": "Signalé réglé — le gabbaï vérifie",

    // — Confirmation —
    "declare.done_title": "Merci\u00a0!",
    "declare.done_body": "Le gabbaï va vérifier. Vous ne recevrez plus de rappel pour cette promesse en attendant.",
    "declare.done_back": "Retour",

    // — Déclaration déjà envoyée (en attente de vérification) —
    "declare.pending_title": "Vous nous avez signalé avoir réglé",
    "declare.pending_body": "{detail}. Le gabbaï va vérifier. Vous ne recevrez plus de rappel pour cette promesse en attendant.",
    "declare.pending_edit": "Corriger ma déclaration",
    "declare.detail_on": "{method}, le {date}",
  },
  en: {
    "declare.link_title": "I have already paid",
    "declare.link_hint": "Paid in cash, by cheque or bank transfer? Let us know and the gabbai will check.",

    "declare.back": "Back to payment",
    "declare.title": "How did you pay?",
    "declare.for_pledge": "For: {motive} — {amount}",
    "declare.method_especes": "Cash",
    "declare.method_cheque": "Cheque",
    "declare.method_virement": "Bank transfer",
    "declare.method_autre": "Other",
    "declare.date_label": "Payment date",
    "declare.note_label": "A note for the gabbai",
    "declare.note_placeholder": "E.g. cheque handed in after the Shabbat service",
    "declare.optional": "optional",
    "declare.submit": "Send",
    "declare.choose_first": "First choose how you paid.",
    "declare.error": "Could not send — please retry.",
    "declare.error_rate": "Too many attempts. Please try again in a few minutes.",
    "declare.error_closed": "This link can no longer be used to report a payment.",
    "declare.error_settled": "This pledge is already recorded as paid. Nothing to report, thank you!",
    "declare.error_refused": "The synagogue has already checked your report. Please contact the gabbai.",
    "declare.choose_pledge": "Go back to the payment page and tick the pledge you have already paid.",

    "declare.nothing_title": "All settled, thank you!",
    "declare.nothing_body": "No pledge is awaiting payment on this link.",

    "declare.line_badge": "Reported paid on {date} — the gabbai is checking",
    "declare.line_badge_nodate": "Reported paid — the gabbai is checking",

    "declare.done_title": "Thank you!",
    "declare.done_body": "The gabbai will check. You will not receive any more reminders for this pledge in the meantime.",
    "declare.done_back": "Back",

    "declare.pending_title": "You told us you have already paid",
    "declare.pending_body": "{detail}. The gabbai will check. You will not receive any more reminders for this pledge in the meantime.",
    "declare.pending_edit": "Correct my report",
    "declare.detail_on": "{method}, on {date}",
  },
};

export default declare;
